const REPORT_FIELDS = [
  ["client_name", "Client Name"],
  ["report_title", "Report Title"],
  ["assessment_type", "Assessment Type"],
  ["start_date", "Start Date"],
  ["active_testing_date", "Active Testing"],
  ["report_delivery_date", "Report Delivery"],
  ["testers", "Testers"],
];

const REPORT_TEXTAREAS = [
  ["confidentiality_notice", "Confidentiality Notice"],
  ["project_details_overview", "Project Details Overview"],
  ["scope_summary", "Scope Summary"],
  ["testing_notes", "Notes About What Was Tested"],
  ["methodology_notes", "Methodology Notes"],
  ["report_notes", "Report Notes"],
];

export default function ReportHeader({
  report,
  onChange,
  onSave,
  onGenerateExecutiveSummary,
  onGenerateMethodology,
  isSaving,
  isGeneratingExecutiveSummary,
  isGeneratingMethodology,
}) {
  return (
    <section className="panel report-header-panel">
      <div className="panel-header">
        <div>
          <p className="eyebrow">Metadata</p>
          <h1>{report.report_title || "Untitled Report"}</h1>
        </div>
        <div className="toolbar-row">
          <button type="button" className="secondary-button" onClick={onSave} disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Metadata"}
          </button>
        </div>
      </div>

      <div className="report-grid">
        {REPORT_FIELDS.map(([field, label]) => (
          <label key={field} className="field">
            <span>{label}</span>
            <input
              type={field.includes("date") ? "date" : "text"}
              value={report[field] || ""}
              onChange={(event) => onChange(field, event.target.value)}
            />
          </label>
        ))}
      </div>

      <div className="report-grid report-grid-wide">
        {REPORT_TEXTAREAS.map(([field, label]) => (
          <label key={field} className="field field-wide">
            <span>{label}</span>
            <textarea
              rows={4}
              value={report[field] || ""}
              onChange={(event) => onChange(field, event.target.value)}
            />
          </label>
        ))}
      </div>
    </section>
  );
}
